// src/App.js
import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import "@fontsource/poppins";
import AdminNavigation from "navigation/adminNavigation";
import { AdminModal, FullScreenModal, ToastWrapper } from "components/atoms";

const App = () => {
  return (
    <>
      <ToastWrapper />
      <AdminModal />
      <FullScreenModal />
      <Routes>
        <Route path="/*" element={<AdminNavigation />} />
      </Routes>
    </>
  );
};

export default App;
